import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconMarketing(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M14 8a.5.5 0 0 1-.5.5H8a.5.5 0 1 1 0-1h5.5a.5.5 0 0 1 .5.5M8 4.5h5.5a.5.5 0 1 0 0-1H8a.5.5 0 0 0 0 1m5.5 7H8a.5.5 0 0 0 0 1h5.5a.5.5 0 1 0 0-1M5.147 2.646 3.5 4.293l-.646-.647a.5.5 0 0 0-.707.708l1 1a.5.5 0 0 0 .707 0l2-2a.5.5 0 1 0-.707-.708m0 4L3.5 8.293l-.646-.647a.5.5 0 0 0-.707.708l1 1a.5.5 0 0 0 .707 0l2-2a.5.5 0 1 0-.707-.708m0 4L3.5 12.293l-.646-.647a.5.5 0 1 0-.707.708l1 1a.5.5 0 0 0 .707 0l2-2a.5.5 0 0 0-.707-.708"
      />
    </SVGIcon>
  );
}
